export default __webpack_public_path__ + "static/media/switch-compare-checkbox.35fe8207.svg";